<template>
  <TabBar activeTabName="devices" />
  <DeviceMainList />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import CustomerMainList from '@/components/fleet/CustomerMainList.vue'
import SiteMainList from '@/components/fleet/SiteMainList.vue'
import DeviceMainList from '@/components/fleet/DeviceMainList.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    CustomerMainList,
    SiteMainList,
    DeviceMainList,
    TabBar
  }
})
export default class FleetHome extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Devices', '#/fleet', '')
  }
}
</script>
